import type { SxProps, Theme } from '@mui/material/styles';

export const standardDataGridSx = {
  backgroundColor: '#fafafa',
  border: '1px solid #e0e0e0',
  borderRadius: 1,
  '& .MuiDataGrid-topContainer, & .MuiDataGrid-columnHeaders, & .MuiDataGrid-columnHeader': {
    backgroundColor: '#702B9D',
  },
  '& .MuiDataGrid-columnHeader': {
    color: '#fff',
    fontWeight: 700,
  },
  '& .MuiDataGrid-columnHeaderTitle': {
    color: '#fff',
    fontWeight: 700,
  },
  '& .MuiDataGrid-columnSeparator': {
    color: 'rgba(255,255,255,0.45)',
  },
  '& .MuiDataGrid-cell': {
    alignItems: 'center',
    borderRight: '1px solid rgba(224, 224, 224, 1)',
    color: 'rgba(0, 0, 0, 0.87)',
    display: 'flex',
  },
  '& .MuiDataGrid-cell--editing': {
    alignItems: 'stretch',
  },
  '& .MuiDataGrid-row:hover': {
    backgroundColor: '#f5f0ff',
  },
  '& .MuiDataGrid-virtualScroller': {
    backgroundColor: '#ffffff',
  },
} satisfies SxProps<Theme>;
